module.exports = __webpack_public_path__ + "media/src/images/page03_zu_worksheet_02-2d51ac443ebe01b983d3aafa8d9e0dae.png";